// Shared lazy pdf.js loader. Cached at module level so the worker is
// initialised once, on the first PDF render anywhere on the page (preview or
// annotations editor).
let pdfjsPromise: Promise<typeof import('pdfjs-dist')> | null = null;

export function getPdfJs() {
  if (!pdfjsPromise) {
    pdfjsPromise = import('pdfjs-dist').then((lib) => {
      lib.GlobalWorkerOptions.workerSrc = new URL(
        'pdfjs-dist/build/pdf.worker.mjs',
        import.meta.url,
      ).toString();
      return lib;
    });
  }
  return pdfjsPromise;
}